module.exports = __webpack_public_path__ + "static/media/birthday.c776a55d.svg";